// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"4fc04524158d7e5b4290","966":"b178705079809261f957"}[chunkId] + ".js";
};